import { ReactNode, useContext, MouseEvent, useMemo } from "react";
import Accordion, { AccordionContext } from "../accordion/Accordion";
import { motion } from "framer-motion";
import { BiChevronRight, BiTrash, BiQuestionMark } from "react-icons/bi";
import { Note } from "../../types/modulesInterfaces";
import { useAppDispatch, useAppSelector, useCustomTranslation, usePermissions } from "../../app/hooks";
import { selectCurrentBuilder, setActiveAction } from "../../app/features/builder/builderSlice";
import { Actions } from "../../types/interfaces";
import { useLocation } from "react-router-dom";
import Spinner from "@components/spinner/Spinner";

/* TODO: add possible icons for comments/notes/help */

const FormSubmodule = ({
	children,
	submoduleName,
	removeHandler,
	note,
	removeLoading,
	className,
	initiallyOpen = true,
}: {
	children: ReactNode;
	submoduleName: string;
	removeHandler?: () => void;
	note?: Note;
	removeLoading?: boolean;
	className?: string;
	initiallyOpen?: boolean;
}) => {
	const header = submoduleName ? (
		<SubmoduleHeader
			label={submoduleName}
			removeHandler={removeHandler}
			note={note}
			removeLoading={removeLoading}
		/>
	) : null;
	return (
		<Accordion header={header} className={className} initiallyOpen={initiallyOpen}>
			<div className="d-flex f-column">{children}</div>
		</Accordion>
	);
};

const SubmoduleHeader = ({
	label,
	removeHandler,
	note,
	removeLoading,
}: {
	label: string;
	removeHandler?: () => void;
	note?: Note;
	removeLoading?: boolean;
}) => {
	const { isOpen, toggleOpen } = useContext(AccordionContext);
	const translatedLabel = useCustomTranslation(label);
	const handleClick = (e: MouseEvent<SVGElement>) => {
		e.stopPropagation();
		if (removeHandler) removeHandler();
	};

	const { pathname } = useLocation()
	const { isPublic } = usePermissions();
	const showQuestionMark = useMemo(() => {
		return !isPublic ? pathname.split("/")[1] === "builder" : pathname.split("/")[2] === "builder";
	}, [pathname, isPublic])

	const dispatch = useAppDispatch();
	const { activeAction } = useAppSelector(selectCurrentBuilder);
	const handleQuestionmarkClick = (e: MouseEvent) => {
		e.stopPropagation();
		if (activeAction !== Actions.Definitions)
			dispatch(setActiveAction(Actions.Definitions));
	}

	return (
		<div className="submodule-header pos-relative ms-2" onClick={() => toggleOpen()}>
			<div className="submodule-header-arrow">
				<motion.div
					animate={{
						rotate: isOpen ? 90 : 0,
					}}
					className="h-100 d-flex align-items-center justify-content-center"
				>
					<BiChevronRight size={24} color="rgba(28, 27, 31, 0.5)" />
				</motion.div>
			</div>
			<h2 className="ff-medium fs-13">{translatedLabel ?? label}</h2>
			{removeHandler && !removeLoading ? (
				<BiTrash
					className="ms-1"
					size={20}
					color="var(--gray)"
					onClick={handleClick}
				/>
			) : removeLoading ? (
				<Spinner size={20} isBlack className="ms-1" />
			) : null}

			{
				showQuestionMark ?
					<div className="definitions-questionmark">
						<BiQuestionMark
							className="ms-1"
							size={20}
							color="#50A2A7"
							onClick={handleQuestionmarkClick} />
					</div>
					: null}
		</div>
	);
};

export default FormSubmodule;
